define.alias("shared/components/shared/expandable-truncated-text", "calendar/components/shared/expandable-truncated-text");